import { routeBirdieProgressRow } from 'src/store/birdiePutts'
import type { NormalizedRace } from 'src/store/types'
import type { RaceDTO } from 'src/services/supabase/queries'
import type { RaceRowDTO } from 'src/types/infra/supabase/RaceRowDTO'
import type { Race, LightningBoostType } from '../../domain/Race'
import { RaceEventMap } from '../RaceEventMap'

export const fromRaceDTO = (race: RaceDTO): Race => {
  return {
    uuid: race.id,
    round: race.round,
    createdAt: race.created_at,
    raceConfigurationId: race.race_configuration_id,
    // Hydration twin of the socket branch: Birdie's `putt_result` rows are
    // routed into the board's own slice and kept OUT of `raceEvents`. Exact
    // type set only — `race_paused` / `race_resumed` map through as today.
    raceEvents: race.race_event
      .filter((row) => !routeBirdieProgressRow(row))
      .map(RaceEventMap.fromRaceEventRowDTO),
    isLightningRound: race.is_lightning_round ?? false,
    lightningBoostType: (race.lightning_boost_type as LightningBoostType) ?? null,
    lightningBoostPercent: race.lightning_boost_percent ?? null,
    lightningBoostedItems: race.lightning_boosted_items ?? null
  }
}

export const fromRaceRowDTO = (raceRow: RaceRowDTO): Omit<Race, 'raceEvents'> => {
  return {
    uuid: raceRow.id,
    round: raceRow.round,
    createdAt: raceRow.created_at,
    raceConfigurationId: raceRow.race_configuration_id,
    isLightningRound: raceRow.is_lightning_round ?? false,
    lightningBoostType: (raceRow.lightning_boost_type as LightningBoostType) ?? null,
    lightningBoostPercent: raceRow.lightning_boost_percent ?? null,
    lightningBoostedItems: raceRow.lightning_boosted_items ?? null
  }
}

export const toNormalizedRace = (race: Race): NormalizedRace => {
  return {
    id: race.uuid,
    createdAt: race.createdAt,
    round: race.round,
    raceConfigurationId: race.raceConfigurationId,
    raceEventIds: race.raceEvents.map((event) => event.uuid),
    isLightningRound: race.isLightningRound,
    lightningBoostType: race.lightningBoostType,
    lightningBoostPercent: race.lightningBoostPercent,
    lightningBoostedItems: race.lightningBoostedItems
  }
}
